import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

/**
 * Contact information fields for the BUSINESS registration form.
 * Company Name, Business Registration Number, Director details, Office Address, etc.
 */
export const BusinessContactFields = ({ formData, fieldErrors, handleInputChange, validateField }) => {
  const err = (k) => fieldErrors[k] ? 'border-red-500 focus-visible:ring-red-500' : '';
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="companyName">Company Name <span className="text-red-500">*</span></Label>
        <Input id="companyName" value={formData.companyName} onChange={(e) => handleInputChange('companyName', e.target.value)} placeholder="Enter company name"
          aria-invalid={!!fieldErrors.companyName} className={err('companyName')} required />
        {fieldErrors.companyName && <p className="text-xs text-red-500">{fieldErrors.companyName}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="registrationNo">Business Registration Number <span className="text-red-500">*</span></Label>
        <Input id="registrationNo" value={formData.registrationNo} onChange={(e) => handleInputChange('registrationNo', e.target.value)} placeholder="Enter business registration number"
          aria-invalid={!!fieldErrors.registrationNo} className={err('registrationNo')} required />
        {fieldErrors.registrationNo && <p className="text-xs text-red-500">{fieldErrors.registrationNo}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="directorName">Director Full Name <span className="text-red-500">*</span></Label>
        <Input id="directorName" value={formData.directorName} onChange={(e) => handleInputChange('directorName', e.target.value)} placeholder="Enter director full name"
          aria-invalid={!!fieldErrors.directorName} className={err('directorName')} required />
        {fieldErrors.directorName && <p className="text-xs text-red-500">{fieldErrors.directorName}</p>}
      </div>
      {/* Anti-bot honeypot — placed right after the Director Full Name so it looks like a natural follow-up field to bots. Invisible to real users. */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          opacity: 0,
          height: 0,
          width: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      >
        <label htmlFor="nickname-biz">Nickname</label>
        <input
          id="nickname-biz"
          type="text"
          name="Nickname"
          tabIndex={-1}
          autoComplete="off"
          required
          defaultValue=""
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="directorNric">Director NRIC No./Passport No. <span className="text-red-500">*</span></Label>
        <Input id="directorNric" value={formData.directorNric} onChange={(e) => handleInputChange('directorNric', e.target.value)} placeholder="Enter director NRIC/passport number"
          aria-invalid={!!fieldErrors.directorNric} className={err('directorNric')} required />
        {fieldErrors.directorNric && <p className="text-xs text-red-500">{fieldErrors.directorNric}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="biz-mobile">Mobile No. <span className="text-red-500">*</span></Label>
        <Input id="biz-mobile" type="tel" value={formData.mobile}
          onChange={(e) => handleInputChange('mobile', e.target.value)}
          onBlur={(e) => validateField('bizMobile', e.target.value)}
          placeholder="Enter mobile number"
          aria-invalid={!!fieldErrors.bizMobile} className={err('bizMobile')} required />
        {fieldErrors.bizMobile && <p className="text-xs text-red-500">{fieldErrors.bizMobile}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="biz-email">Email Address <span className="text-red-500">*</span></Label>
        <Input id="biz-email" type="email" value={formData.email}
          onChange={(e) => handleInputChange('email', e.target.value)}
          onBlur={(e) => validateField('bizEmail', e.target.value)}
          placeholder="Enter email address"
          aria-invalid={!!fieldErrors.bizEmail} className={err('bizEmail')} required />
        {fieldErrors.bizEmail && <p className="text-xs text-red-500">{fieldErrors.bizEmail}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="officeAddress">Office Installation Address <span className="text-red-500">*</span></Label>
        <Textarea id="officeAddress" value={formData.officeAddress} onChange={(e) => handleInputChange('officeAddress', e.target.value)} placeholder="Enter office installation address" rows={3}
          aria-invalid={!!fieldErrors.officeAddress} className={err('officeAddress')} required />
        {fieldErrors.officeAddress && <p className="text-xs text-red-500">{fieldErrors.officeAddress}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="biz-postcode">Postcode <span className="text-red-500">*</span></Label>
        <Input id="biz-postcode" value={formData.postcode || ''} onChange={(e) => handleInputChange('postcode', e.target.value)} placeholder="Enter postcode"
          aria-invalid={!!fieldErrors.postcode} className={err('postcode')} required />
        {fieldErrors.postcode && <p className="text-xs text-red-500">{fieldErrors.postcode}</p>}
      </div>
      <div className="space-y-2">
        <Label htmlFor="biz-installationDay">Preferred Installation Day <span className="text-red-500">*</span></Label>
        <Select onValueChange={(v) => handleInputChange('installationDay', v)} value={formData.installationDay}>
          <SelectTrigger data-field-error="installationDay" className={fieldErrors.installationDay ? 'border-red-500 focus:ring-red-500' : ''}>
            <SelectValue placeholder="Please Select" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="asap">As Soon As Possible</SelectItem>
            <SelectItem value="weekday">Weekday Only (Monday - Friday)</SelectItem>
            <SelectItem value="weekend">Weekend Only (Saturday - Sunday)</SelectItem>
          </SelectContent>
        </Select>
        {fieldErrors.installationDay && <p className="text-xs text-red-500">{fieldErrors.installationDay}</p>}
      </div>
    </>
  );
};
